import React from "react";
import clsx from "clsx";
import ErrorHelper from "../../Errors/ErrorHelper";
import CustomerSelect from "../../Selects/CustomerSelect";
import PreviewPopoverLink from "../../PreviewPopover/PreviewPopoverLink";

export default class OrderCardBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="orders">
        {this.props.errors ? ErrorHelper.renderErrors(this.props.errors, ['status']) : null}
        <div>
          <div className="row">
            <div className="col-sm-3 form-group" style={{marginBottom: '0px'}}>
              <label>{I18n.t('status')}</label>
              <br />
              {this.props.read_only
              ?
              <div>{this.props.order.status ? I18n.t(this.props.order.status) : I18n.t('submitted')}</div>
              :
              <select defaultValue={this.props.order.status} name='status' className={ErrorHelper.renderFieldClasses('status', this.props.errors, 'form-control')} onChange={this.props.onChangeOrder}>
                <option value="submitted">{I18n.t('submitted')}</option>
                <option value="completed">{I18n.t('completed')}</option>
              </select>
              }
              {ErrorHelper.renderFieldErrors('status', this.props.errors)}
            </div>
            <div className="col-sm-3 form-group" style={{marginBottom: '0px'}}>
              <label>{`${I18n.t('customer')}*`}</label>
              <br />
              {
                this.props.new_record
                ?
                <div>
                  <CustomerSelect onChange={this.props.onChangeCustomer} user={this.props.order.customer} hasError={ErrorHelper.renderFieldClasses('customer', this.props.errors, 'form-control')} />
                  <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="btn btn-link btn-xs modal-iframe new-customer-button">{I18n.t('new_customer')}</a>
                </div>
                : 
                this.props.order.customer
                ?
                <div>
                  <PreviewPopoverLink model_type={'customer'} model_id={this.props.order.customer.id} text={`${this.props.order.customer.first_name} ${this.props.order.customer.middle_name} ${this.props.order.customer.last_name}`} date_format={this.props.date_format} time_format={this.props.time_format} />
                </div>
                :
                <div>{I18n.t('none')}</div>
              }
              {ErrorHelper.renderFieldErrors('customer', this.props.errors)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
